/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Collection health of a single system information source.
 */
export enum SystemInfoSourceStatusType {
  SystemInfoSourceStatusHealthy = 'Healthy',
  SystemInfoSourceStatusError = 'Error',
  SystemInfoSourceStatusUnknown = 'Unknown',
}
